import axios from 'axios';
import { StudentInfo } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export interface TermsAcceptedData {
  userAgreement: {
    agreed: boolean;
    version: string;
    agreedAt: string;
  };
  privacyPolicy: {
    agreed: boolean;
    version: string;
    agreedAt: string;
  };
}

export interface RegisterData {
  name: string;
  email: string;
  password: string;
  role?: 'student' | 'teacher';
  teacherInfo?: {
    institution: string;
    department: string;
  };
  courseCode?: string;
  termsAccepted?: TermsAcceptedData;
}

export interface LoginData {
  email: string;
  password: string;
}

export interface UpdateStudentInfoData {
  studentInfo: StudentInfo;
}

export interface AuthResponse {
  success: boolean;
  message?: string;
  data?: {
    token: string;
    user: {
      id: string;
      name: string;
      email: string;
      createdAt: string;
      isAdmin?: boolean;
      learningProgress: any;
      studentInfo?: StudentInfo;
      infoCompleted?: boolean;
    };
  };
}

export const authApi = {
  register: async (data: RegisterData): Promise<AuthResponse> => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/register`, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Registration failed');
    }
  },

  login: async (data: LoginData): Promise<AuthResponse> => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  },

  logout: async (token: string): Promise<void> => {
    await axios.post(`${API_BASE_URL}/auth/logout`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  getProfile: async (token: string): Promise<AuthResponse> => {
    try {
      const response = await axios.get(`${API_BASE_URL}/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch profile');
    }
  },

  updateStudentInfo: async (token: string, data: UpdateStudentInfoData): Promise<AuthResponse> => {
    try {
      const response = await axios.put(`${API_BASE_URL}/auth/student-info`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to update student information');
    }
  }
};
